import React from 'react';
import { arrayOf, bool, shape, element, array, object, string, oneOfType, node, func, } from 'prop-types';
import { Route, useLocation, useRouteMatch } from 'react-router';
import { Link } from 'react-router-dom';
import setClass from '../../common/set-class';
const Tabs = ({ tabs, children, className, style }) => {
    const match = useRouteMatch();
    const { pathname } = useLocation();
    const currentSubPath = pathname.replace(match.url, '').replace(/^\//, '');
    const getUrl = (route) => `${match.url}${route ? `/${route}` : ''}`;
    const getPath = (route) => `${match.path}${route ? `/${route}` : ''}`;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: setClass('b-tabs', className), style: style }, tabs.map((tab) => (React.createElement("div", { key: tab.route, className: "b-tabs__tab-container" },
            React.createElement(Link, { onClick: (e) => {
                    if (tab.disabled) {
                        e.preventDefault();
                    }
                }, to: tab.disabled ? '' : getUrl(tab.route), className: setClass([
                    'decorate-off',
                    'b-tabs__tab',
                    currentSubPath === (tab.route || '')
                        ? 'b-txt-ctrl1 --active'
                        : 'b-txt-ctrl2',
                    tab.disabled && 'b-txt-light b-tabs__tab--disabled',
                ]) }, typeof tab.label === 'function'
                ? tab.label(currentSubPath === tab.route)
                : tab.label),
            React.createElement("div", { className: "b-tabs__tab-border" }))))),
        React.Children.map(children, (child) => {
            const tab = tabs.find((t) => child && [t.label, t.tabId].some((id) => id === child.props.tabid));
            return (React.createElement(React.Fragment, null, tab?.disabled ? null : (React.createElement(Route, { exact: true, path: getPath(tab?.route) }, child))));
        })));
};
Tabs.propTypes = {
    className: string,
    tabs: arrayOf(shape({
        label: oneOfType([string, node, func]).isRequired,
        tabId: string,
        route: string,
        disabled: bool,
    })).isRequired,
    children: oneOfType([array, element]).isRequired,
    style: object,
};
Tabs.defaultProps = {
    className: '',
    style: {},
};
export default Tabs;
